import { render, staticRenderFns } from "./ButtonSubmit.vue?vue&type=template&id=400ab4bd"
import script from "./ButtonSubmit.vue?vue&type=script&lang=js"
export * from "./ButtonSubmit.vue?vue&type=script&lang=js"
import style0 from "./ButtonSubmit.vue?vue&type=style&index=0&id=400ab4bd&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports